__turbopack_export_value__({
  "className": "poppins_d5fb820a-module__UCUl0G__className",
  "variable": "poppins_d5fb820a-module__UCUl0G__variable",
});
